import { api } from "@/lib/api";
import {
  ReservationServiceDto,
  reservationServiceDtoListSchema,
  reservationServiceFromDto,
  ReservationServicesWithFulFillmentsDtoListSchema,
  ReservationServiceWithfulfillmentsDto,
  reservationServiceWithFulfillmentsFromDto,
} from "@/models";
import { queryOptions, useQuery } from "@tanstack/react-query";

export function getReservationServicesQueryOptions(reservationId: string) {
  return queryOptions({
    queryKey: ["reservation-services", reservationId],
    queryFn: async () => {
      const result: Array<ReservationServiceDto> = [];
      let page = 0;
      let hasNextPage = true;
      while (hasNextPage) {
        page += 1;
        const res = await api.getWithCache(
          "/api/reservation-services",
          reservationServiceDtoListSchema,
          {
            query: {
              page: page.toString(),
            },
            filters: {
              ReservationId: Number.parseInt(reservationId),
            },
            projection: ["ReservationServiceClients"],
          },
        );
        result.push(...res.Data);
        hasNextPage = res.PageInfo.HasNextPage;
      }
      return result.map(reservationServiceFromDto);
    },
  });
}

export function useGetReservationServices(reservationId: string) {
  return useQuery({
    ...getReservationServicesQueryOptions(reservationId),
  });
}
export const getAllReservationServicesQueryOptions = queryOptions({
  queryKey: ["all-reservation-services"],
  queryFn: async () => {
    const result: Array<ReservationServiceDto> = [];
    let page = 0;
    let hasNextPage = true;
    while (hasNextPage) {
      page += 1;
      const res = await api.getWithCache(
        "/api/reservation-services",
        reservationServiceDtoListSchema,
        {
          query: {
            page: page.toString(),
          },
        },
      );
      result.push(...res.Data);
      hasNextPage = res.PageInfo.HasNextPage;
    }
    return result.map(reservationServiceFromDto);
  },
});

export function useGetAllReservationServices() {
  return useQuery({
    ...getAllReservationServicesQueryOptions,
  });
}

export function getAllReservationServicesWithFulfillmentsQueryOptions(
  reservationId: string,
) {
  return queryOptions({
    queryKey: ["reservation-services-fulfillments", reservationId],
    queryFn: async () => {
      const result: Array<ReservationServiceWithfulfillmentsDto> = [];
      let page = 0;
      let hasNextPage = true;
      while (hasNextPage) {
        page += 1;
        const res = await api.getWithCache(
          "/api/reservation-services",
          ReservationServicesWithFulFillmentsDtoListSchema,
          {
            query: {
              page: page.toString(),
            },
            filters: {
              ReservationId: Number.parseInt(reservationId),
            },
            projection: ["FulfillmentReservationServices.Fulfillment"],
          },
        );
        result.push(...res.Data);
        hasNextPage = res.PageInfo.HasNextPage;
      }
      return result.map(reservationServiceWithFulfillmentsFromDto);
    },
  });
}

export function useGetAllReservationServicesWithfulfillments(
  reservationId: string,
) {
  return useQuery({
    ...getAllReservationServicesWithFulfillmentsQueryOptions(reservationId),
  });
}
